export default "__VITE_ASSET__07db90c5__"